import { render, staticRenderFns } from "./BuyLists.vue?vue&type=template&id=d5632924&"
import script from "./BuyLists.vue?vue&type=script&lang=js&"
export * from "./BuyLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports